import { Box, CircularProgress } from '@mui/material';
import { LinearProgressWithLabel } from '../../components/LinearProgressWithLabel';
import { FC } from 'react';

interface Props {
  downloadAssetCount: string;
  downloadProgress: number;
  currentAssetName?: string;
}

const DownloadProgress: FC<Props> = ({
  downloadAssetCount,
  downloadProgress,
  currentAssetName,
}) => {
  return (
    <Box
      justifyContent="center"
      alignItems="center"
      display="flex"
      height="100vh"
      flexDirection="column"
    >
      <CircularProgress size={100} />
      <p style={{ marginTop: 30 }}>Downloading media files...</p>
      {currentAssetName && <p style={{ margin: 0 }}>{currentAssetName}</p>}
      <p style={{ marginTop: 30, marginBottom: 30 }}>{downloadAssetCount}</p>
      <Box width={'80%'}>
        <LinearProgressWithLabel value={downloadProgress} />
      </Box>
    </Box>
  );
};

export default DownloadProgress;
